import { createFileRoute } from '@tanstack/react-router'
import { ClientDetail } from '@/modules/client-knowledge/pages/ClientDetail'

export const Route = createFileRoute('/clients/$clientId')({
  component: ClientDetail,
})
